<template>
  <button class="btn btn-link mb-2" type="button" @click="toggle">
    <i class="bi bi-filter" /> {{ $t("filtros") }}
  </button>
  <div ref="collapse" class="collapse mb-4">
    <div class="card card-body border-primary">
      <slot />
    </div>
  </div>
</template>

<script>
import { Collapse } from 'bootstrap';

export default {
  data: () => ({ collapse: null }),
  mounted() {
    this.collapse = Collapse.getOrCreateInstance(this.$refs.collapse, { toggle: false });
  },
  expose: ['toggle'],
  unmounted() { this.collapse.dispose(); },
  methods: {
    toggle() { this.collapse.toggle(); },
  },
};
</script>
